<template>
<div class="meter-apportion" ref="meterApportion">
  <div class="meter-apportion-tree" ref="meterApportionTree">
    <MeterTreeComponent :project_id="project_id" ref="MeterTreeComponentRef" :width="leftWidth" height="calc(100vh - 200px)" :is-checkbox="true" @onCheck="onClickMeter" />
  </div>
  <div class="resize" title="左右侧边栏" ref="resize">⋮</div>
  <div class="meter-apportion-list" ref="meterApportionList">
    <div>
      <div style="margin-bottom: 10px;">
        <el-button size="mini" type="primary" @click="pageChange(1)">刷新</el-button>
      </div>
      <div>
        <el-input v-model="mainObj.house_name" placeholder="房产名称" style="width: 320px;" size="mini" disabled></el-input>
        <el-button size="mini" @click="selectHouseList()">选择房产</el-button>
      </div>
      <div class="header-tip">
        仪表数：{{pageData.total}}
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="pageData.data"
      border height="calc(100vh - 350px)" width="99%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        prop="meter_number"
        label="仪表编号"
        width="120" fixed></el-table-column>
      <el-table-column
        prop="meter_name"
        label="仪表名称"
        width="200">
      </el-table-column>
      <el-table-column
        prop="customer_name"
        label="分摊对象"
        width="150">
        <template slot-scope="scope">
          <el-link type="primary" >{{scope.row.customer_name||'--'}}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="apportion_type_name"
        label="分摊模式"
        width="90">
      </el-table-column>
      <el-table-column
        prop="value"
        label="系数"
        width="120">
        <template slot-scope="scope">
          <input type="number" class="number-input" v-model="scope.row.value" @change="updateMeterApportionObject(scope.row.meter_id,'value',scope.row.value)" />
        </template>
      </el-table-column>
      <el-table-column
        prop="total"
        label="基数"
        width="150">
        <template slot-scope="scope">
          <input disabled type="number" class="number-input" v-model="scope.row.total" @change="updateMeterApportionObject(scope.row.meter_id,'total',scope.row.total)" />
        </template>
      </el-table-column>
      <el-table-column
        prop="proportion"
        label="分摊占比"
        width="180">
        <template slot-scope="scope">
          <input disabled type="number" class="number-input" v-model="scope.row.proportion" @change="updateMeterApportionObject(scope.row.meter_id,'proportion',scope.row.proportion)" />
        </template>
      </el-table-column>
      <el-table-column
        prop="proportion_ext"
        label="占比扩展"
        width="100">
        <template slot-scope="scope">
          <input type="number" class="number-input" v-model="scope.row.proportion_ext" @change="updateMeterApportionObject(scope.row.meter_id,'proportion_ext',scope.row.proportion_ext)" />
        </template>
      </el-table-column>
      <el-table-column
        prop="proportion_loss"
        label="损耗占比"
        width="100">
        <template slot-scope="scope">
          <input type="number" class="number-input" v-model="scope.row.proportion_loss" @change="updateMeterApportionObject(scope.row.meter_id,'proportion_loss',scope.row.proportion_loss)" />
        </template>
      </el-table-column>
      <el-table-column
        prop="is_generate_expenses"
        label="是否生成费用"
        width="100">
        <template slot-scope="scope">
          <!--        <input type="number" class="number-input" v-model="scope.row.is_generate_expenses" @change="setValue(scope.row.house_id,'is_generate_expenses',scope.row.is_generate_expenses)" />-->
          <el-switch v-model="scope.row.is_generate_expenses" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="updateMeterApportionObject(scope.row.meter_id,'is_generate_expenses',scope.row.is_generate_expenses)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="fixed_amount"
        label="固定金额"
        width="100">
        <template slot-scope="scope">
          <input type="number" class="number-input" v-model="scope.row.fixed_amount" @change="updateMeterApportionObject(scope.row.meter_id,'fixed_amount',scope.row.fixed_amount)" />
        </template>
      </el-table-column>
      <el-table-column
        prop="area"
        label="分摊面积"
        width="120">
      </el-table-column>
      <el-table-column
        prop="floor"
        label="楼层"
        width="100">
      </el-table-column>
      <el-table-column
        label="操作" width="120px" fixed="right">
        <template slot-scope="scope">
<!--          <el-button type="primary" size="mini" icon="el-icon-edit" >设置</el-button>-->
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteMeterApportionObject(scope.row.meter_id)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px;text-align: center;display: flex;justify-content: center;align-items: center;">
      <el-input v-model="pageData.per_page" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
      <Page :total="pageData.total" :current-page="pageData.current_page" :page-size="pageData.per_page" @on-change="pageChange" show-total />
    </div>
  </div>
  <ApportionWin ref="ApportionWinRef" />
</div>
</template>

<script>
import ApportionWin from "./components/apportion/ApportionWin";
// let meter_list=[];
let meter_tree=[];
import MeterTreeComponent from "./components/MeterTreeComponent";
import MeterTreeEditorComponent from "./components/MeterTreeEditorComponent";
import MeterHttp from "../../common/MeterHttp";
import {CommonHelp} from "../../common/CommonHelp";
export default {
  name: "MeterApportionCustomerList",
  components: { ApportionWin, MeterTreeComponent,MeterTreeEditorComponent},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      meter_list:[],
      house_list:[],
      pageData: {
        list: [],
        total: 0,
        per_page: 30,
        page: 1
      },
      loading:false,
      multipleSelection:[],
      leftWidth: '250px',
    }
  },
  mounted(){
    const that=this;
    that.dragControllerLR({
      resize:that.$refs.resize,
      iframe:that.$refs.meterApportion,
      left:that.$refs.meterApportionTree,
      right:that.$refs.meterApportionList
    },({leftWidth})=>{
      that.leftWidth=leftWidth;
    });
    that.pageChange(1);
  },
  methods:{
    getList(){
      const that=this;
      that.loading=true;
      that.multipleSelection=[];
      if(!that.mainObj.house_id){
        that.loading=false;
      }
      CommonHelp.debounce(function () {
        MeterHttp.post('MeterApportion/getMeterApportionCustomerList?user_type='+that.$route.query.type,{
          project_id: that.project_id,
          meter_ids:(that.$refs.MeterTreeComponentRef.getCheckedKeys()||[]).join(','),
          house_id:that.mainObj.house_id,
          page: that.pageData.current_page,
          per_page: that.pageData.per_page,
        },res=>{
          that.loading=false;
          if(res.code){
            that.pageData=res.data;
          }
        })
      }, 500,that)

    },
    onClickMeter(node){
      const that=this;
      // this.$emit("onClickMeter",node)
      meter_tree=node;
      // console.log(node)
      that.meter_list=[];
      that.pageChange(1);
    },
    pageChange(i=1){
      const that=this;
      that.pageData.current_page=i;
      that.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    reGetDate(){
      const that=this;
      that.$refs.MeterTreeComponentRef.getData(list=>{
        console.log(list)
      })

    },
    deleteMeterApportionObject(meter_id){
      const that=this;
      MeterHttp.post('MeterApportion/deleteMeterApportionCustomer?user_type='+that.$route.query.type,{
        project_id: that.project_id,
        house_id:that.mainObj.house_id,
        meter_id: meter_id,
      },res=>{
        if(res.code){
          that.$message.success('添加成功');
          that.pageChange(1);
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    updateCustomer(){
      const that=this;
      let meter_ids=that.$refs.MeterTreeComponentRef.getCheckedKeys()
      MeterHttp.post('MeterApportionObject/updateCustomer?user_type='+that.$route.query.type,{
        project_id: that.project_id,
        house_id:that.mainObj.house_id,
        meter_ids: (meter_ids||[]).join(','),
      },res=>{
        if(res.code){
          that.$message.success(res.msg);
          that.pageChange(1);
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    dragControllerLR({resize,iframe, left, right},callback) {
      const that=this;
     resize.onmousedown = function (e) {
        //颜色改变提醒
        resize.style.background = "#818181";
        let startX = e.clientX;
        resize.left = resize.offsetLeft;
        // 鼠标拖动事件
        document.onmousemove = function (e) {
          let endX = e.clientX;
          let moveLen = resize.left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
          let maxT = iframe.clientWidth - resize.offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

          if (moveLen < 50) moveLen = 50; // 左边区域的最小宽度为50px
          if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px

          resize.style.left = moveLen; // 设置左侧区域的宽度

          typeof callback=== "function" && callback({
            moveLen: moveLen,
            maxT: maxT,
            leftWidth: (moveLen-5) + "px",
            rightWidth: iframe.clientWidth - moveLen - 10 + "px"
          });

          left.style.width = moveLen + "px";
          right.style.width = iframe.clientWidth - moveLen - 10 + "px";

        };
        // 鼠标松开事件
        // eslint-disable-next-line no-unused-vars
        document.onmouseup = function (evt) {
          //颜色恢复
          resize.style.background = "#d6d6d6";
          document.onmousemove = null;
          document.onmouseup = null;
          resize.releaseCapture && resize.releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
        };
        resize.setCapture && resize.setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
        return false;
      };
    },
    selectHouseList(){

    }

  },
  computed:{
    project_id(){
      return this.mainObj.project_id
    },
    house_ids(){
      return this.house_list.map(ret=>ret.house_id)
    }
  },
  watch:{
    project_id(n,o){
      const that=this;
      if(n){
        setTimeout(()=>{
          that.reGetDate()
        },500);
        that.pageChange();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.meter-apportion{
  display: flex;
  flex-direction: row;
  .meter-apportion-tree{

  }
  .meter-apportion-list{
    width: calc(100% - 260px);
  }
}
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}

/* 拖拽区div样式 */
.resize {
  cursor: w-resize;
  float: left;
  position: relative;
  top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 32px;
  color: white;
  margin:auto 0;
  text-align: center;
  &::before{
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 1px;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    z-index: -1;
  }
}
.number-input{
  background-color: #ffe5d5;
  color: black;
  width: 100%;
  &[disabled]{
    background-color: #ececec;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/MeterApportionCustomerList.vue